import React from 'react';
export const composeRefs = (...refs) => (x) => refs
    .filter((r) => !!r)
    .forEach((ref) => {
    if (typeof ref === 'function') {
        ref(x);
    }
    else {
        ref.current = x;
    }
});
export function isClassComponent(component) {
    var _a;
    return (typeof component === 'function' && !!((_a = component === null || component === void 0 ? void 0 : component.prototype) === null || _a === void 0 ? void 0 : _a.isReactComponent));
}
export function isFunctionComponent(component) {
    return typeof component === 'function';
}
export function isReactComponent(component) {
    return isClassComponent(component) || isFunctionComponent(component);
}
export function isElement(element) {
    return React.isValidElement(element);
}
export function isDOMTypeElement(element) {
    return isElement(element) && typeof element.type === 'string';
}
export function isCompositeTypeElement(element) {
    return isElement(element) && typeof element.type === 'function';
}
//# sourceMappingURL=helpers.js.map